export const toRGBA = (rgba) => {
  if (!rgba) return "transparent";
  const { r = 255, g = 255, b = 255, a = 1 } = rgba;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

export const getFontFamily = (font, fallback = "arial") => {
  if (!font || font === "undefined") {
    return fallback || "arial";
  }
  return font;
};

export const rgbaToHex = (rgba) => { 

  if (!rgba) {
    return {
      hex: void(0),
      alpha: void(0),
    };
  } 
  const { r = 255, g = 255, b = 255, a = 1 } = rgba;

  if (r > 255 || r < 0) {
    console.error("Invalid color r: ", r);
  }
  if (g > 255 || g < 0) {
    console.error("Invalid color g: ", g);
  }
  if (b > 255 || b < 0) {
    console.error("Invalid color b: ", b);
  }
  if (a > 1 || a < 0) {
    console.error("Invalid color a: ", a);
  }
  return {
    hex: "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toLocaleUpperCase(),
    alpha: +(a * 100).toFixed(0),
  } 
}

export const getPaddingString = ({ paddingTop, paddingBottom, paddingRight, paddingLeft }) => {
  return `padding-top: ${paddingTop || 0}px;padding-bottom: ${
    paddingBottom || 0
  }px;padding-right: ${paddingRight || 0}px;padding-left: ${paddingLeft || 0}px;`;
};

export const getMarginString = ({ marginTop, marginBottom, marginRight, marginLeft }) => {
  return `margin-top: ${marginTop || 0}px;margin-bottom: ${
    marginBottom || 0
  }px;margin-right: ${marginRight || 0}px;margin-left: ${marginLeft || 0}px;`;
};


export const styleToString = (style) => {
  return Object.keys(style).reduce((acc, key) => (
      acc + key.split(/(?=[A-Z])/).join('-').toLowerCase() + ':' + style[key] + ';'
  ), '');
};

export const formFieldErrorHtml = ({ id }) => {
  return `<div class="rip-form-error"></div>`;
};


/**
 * Merges two CSS style strings, with the labelInlineStyle string taking precedence.
 * @param {string} baseStyleString - The base CSS style string.
 * @param {string} labelInlineStyle - The CSS style string that should override the base, typically representing inline styles.
 * @returns {string} The merged CSS style string.
 */
export function mergePreviewStyle(baseStyleString, labelInlineStyle) {
  const allStyleDeclarations = [];

  // Ensure parameters are strings, default to empty string if not
  const safeBaseStyle = typeof baseStyleString === 'string' ? baseStyleString : "";
  const safeLabelInlineStyle = typeof labelInlineStyle === 'string' ? labelInlineStyle : "";

  // Add parts from baseStyleString
  if (safeBaseStyle.trim()) {
    safeBaseStyle.trim().split(';').forEach(part => {
      const trimmedPart = part.trim();
      if (trimmedPart) { // Ensure part is not empty after trim
        allStyleDeclarations.push(trimmedPart);
      }
    });
  }

  // Add parts from labelInlineStyle
  // These will come after base parts, so they will override if properties are the same.
  if (safeLabelInlineStyle.trim()) {
    safeLabelInlineStyle.trim().split(';').forEach(part => {
      const trimmedPart = part.trim();
      if (trimmedPart) { // Ensure part is not empty after trim
        allStyleDeclarations.push(trimmedPart);
      }
    });
  }

  // Join all parts with "; ".
  // The browser handles duplicate properties correctly (last one wins).
  let finalStyleStr = allStyleDeclarations.filter(declaration => declaration).join('; ');

  // Optionally, add a trailing semicolon if there are any styles, for neatness.
  if (finalStyleStr) {
    finalStyleStr += ';';
  }

  return finalStyleStr;
}
